import { defineChapter } from '../../define';
import boss from './challenges/boss/meta';
import chainPredict from './challenges/chain-predict/meta';
import groupBy from './challenges/group-by/meta';
import sortMutation from './challenges/sort-mutation/meta';
import totals from './challenges/totals/meta';

export default defineChapter({
  id: 'js-arrays',
  slug: 'arrays',
  title: 'Arrays and iteration',
  position: 5,
  challenges: [chainPredict, groupBy, totals, sortMutation, boss],
});
